import type {
  FormType,
  VisitCategory,
} from "@/api/form-builder-assignments/formBuilderAssignments.types";
import type { CategoryDetailSearch } from "../CategoryDetailPage/CategoryDetailPage";

export interface SlotTarget {
  tenantId: string;
  workOrderType: VisitCategory;
  formType: FormType;
  scope: { clientId?: string; brandId?: string; tradeId?: number; subtradeId?: number };
}

interface CurrentPage {
  pathname: string;
  search: Record<string, unknown>;
}

const SCOPE_KEYS = ["clientId", "brandId", "tradeId", "subtradeId"] as const;

/**
 * The search of the category page that shows the slot's form selector, with the
 * slot highlighted. On that same page already, its search is kept so the
 * titles keep their names; otherwise the page names things from the tree.
 */
export function slotPageSearch(slot: SlotTarget, current?: CurrentPage): CategoryDetailSearch {
  const onSlotPage =
    current?.pathname === `/form-builder/assignments/${slot.workOrderType}` &&
    current.search.entityId === slot.tenantId &&
    SCOPE_KEYS.every((key) => (current.search[key] ?? undefined) === slot.scope[key]);
  const base: CategoryDetailSearch = onSlotPage
    ? (current.search as CategoryDetailSearch)
    : {
        entityId: slot.tenantId,
        ...Object.fromEntries(
          SCOPE_KEYS.filter((key) => slot.scope[key] !== undefined).map((key) => [
            key,
            slot.scope[key],
          ]),
        ),
      };
  return { ...base, formType: slot.formType };
}
